jQuery(document).ready(function($) {

  $(document).foundation();

$('body').on('click','.vbtk-js-menu',function(e){
    if ( $(this).hasClass('nav-closed') ) {
      $(this).addClass('nav-open').removeClass('nav-closed');
      $(this).text('Close');
    }
    else {
      $(this).addClass('nav-closed').removeClass('nav-open');
      $(this).text('Menu');
    }
    $('.page-dimmer').toggleClass('dim-on');
    $('#mobile-nav').toggleClass('nav-open');
    $('body').toggleClass('body-locked');

  });
  
  $('.pb-gallery-wrapper').slick({
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    adaptiveHeight: true,
    dots: false
  });

  $('.pb-gallery-thumbnails .thumbnail').on('click',function(e){
    var thm = $(this), index = thm.index(), gallery = thm.closest('.pb-gallery').find('.slick-slider');
    gallery.slick('slickGoTo',index);
  });

  // Remove empty P tags created by WP inside of Accordion and Orbit
  $('.accordion p:empty, .orbit p:empty').remove();

	// Makes sure last grid item floats left
	$('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
      $(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      $(this).wrap("<div class='flex-video'/>");
    }
  });

  $('body').on('click', '.js-close-ctaslideout', function(e){
    $(this).closest('.consult-slideout').toggleClass('closed');
    $('.find-a-doc-tab').toggleClass('closed');
  });

  $('body').on('click', '.find-a-doc-tab', function(e){
    $(this).closest('.consult-slideout').toggleClass('closed');
    $(this).toggleClass('closed');
  });

  $('.home-testimonials-slider').slick({
    dots: true,
    arrows: false,
  });



  $('.home-bottom-slider').slick({
    dots: true,
    arrows: false,
    customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data('thumb');
        return '<span>'+thumb+'</span>';
    },
  });

  

  $('.filter-form').on('change', function () {
    $(this).submit();
  });

$('.before-after-slider-nav').slick({
    dots: false,
    arrows: true,
    slidesToShow: 10,
    slidesToScroll: 1,
    centerMode: true,
    asNavFor: '.before-after-slider-lg',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 9,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  var jumpoffset = $($(".jump-links-wrapper").offset()).top;

  $(window).on('scroll', function(){
    
    var scrollTop = $(window).scrollTop();
    var headerHeight = $('.header').height();

    var offset = jumpoffset - headerHeight;

    //console.log(offset);

    if (scrollTop >= offset) {
      if ( !( $('.jump-links-wrapper').hasClass('stick-top')) ) {
         $('.jump-links-wrapper').addClass('stick-top');
      }
    }
    else {
      if ( $('.jump-links-wrapper').hasClass('stick-top') ) {
        $('.jump-links-wrapper').removeClass('stick-top');
      }   
    }
  });
   



  $('.before-after-slider-lg').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: '.before-after-slider-nav',
  });


  $('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.slider-nav').slick('slickGoTo', slideno - 1);
  });


});

window.toggleModal = function (id) {
  var el = $('#' + id).toggleClass('active');

  if (el.hasClass('active')) {
    $('html,body').animate({ scrollTop: el.offset().top - 100 } , 'fast');
  }
};